import { EUROPACE_SHOPWINDOW_CONDITION_USAGES } from 'cpool-constants';
import { z } from 'zod';

export const schemaEuropaceFinanzierungszweck = z.nativeEnum(EUROPACE_SHOPWINDOW_CONDITION_USAGES);

export type SchemaEuropaceFinanzierungszweck = z.infer<typeof schemaEuropaceFinanzierungszweck>;
